import { router } from '@/modules/quan-tri-he-thong/router'

export default router
